"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner(props) {
        var _this = _super.call(this, props) || this;
        _this.queueTransitionEnd = [];
        _this.transitionEnd = function () {
            if (_this.queueTransitionEnd.length > 0) {
                var next = _this.queueTransitionEnd.shift();
                _this.setState(next);
            }
        };
        _this.displaySpinner = function () {
            _this.setState({
                inTransition: true,
                screenreaderVisible: true,
                spinnerInDOM: true,
            });
            setTimeout(function () {
                // DOM needs to update before applying class...
                _this.setState({
                    spinnerVisible: true,
                });
                if (_this.srRef.current !== null) {
                    _this.srRef.current.focus();
                }
            }, 100);
            _this.queueTransitionEnd.push({
                inTransition: false,
                isVisible: true,
            });
        };
        _this.hideSpinner = function () {
            _this.setState({
                inTransition: true,
                spinnerVisible: false,
            });
            _this.queueTransitionEnd.push({
                inTransition: false,
                isVisible: false,
                screenreaderVisible: false,
                spinnerInDOM: false,
            });
        };
        _this.srRef = React.createRef();
        if (!_this.props.isVisible) {
            _this.state = {
                inTransition: false,
                isVisible: false,
                loadingTextVisible: false,
                screenreaderVisible: false,
                spinnerInDOM: false,
                spinnerVisible: false,
            };
        }
        else {
            _this.state = {
                inTransition: false,
                isVisible: true,
                loadingTextVisible: true,
                screenreaderVisible: true,
                spinnerInDOM: true,
                spinnerVisible: true,
            };
        }
        return _this;
    }
    Spinner.prototype.componentDidUpdate = function (prevProps) {
        if (this.state.inTransition === false) {
            if (!prevProps.isVisible && this.props.isVisible) {
                // Display the spinner
                this.displaySpinner();
            }
            else if (prevProps.isVisible && !this.props.isVisible) {
                // Hide the spinner
                this.hideSpinner();
            }
            else if (!this.props.isVisible && this.state.isVisible) {
                // The spinner finished displaying, but now it should be hidden
                this.hideSpinner();
            }
            else if (this.props.isVisible && !this.state.isVisible) {
                // The spinner finished hiding, but should be displayed
                this.displaySpinner();
            }
            else if (!this.props.isVisible && this.props.isVisible === this.state.isVisible && typeof this.props.onClose === 'function') {
                // The spinner has finished fade out
                this.props.onClose();
            }
        }
    };
    Spinner.prototype.render = function () {
        var attributes = {
            'aria-atomic': 'true',
            className: 'spinner',
            role: 'status',
        };
        if (this.state.spinnerVisible) {
            attributes.className += ' spinner--visible';
        }
        if (this.props.ariaLive) {
            attributes['aria-live'] = this.props.ariaLive;
        }
        return (React.createElement("div", __assign({}, attributes),
            this.state.spinnerInDOM && (React.createElement("div", { className: "spinner__indicator", "aria-hidden": "true", onTransitionEnd: this.transitionEnd })),
            this.state.loadingTextVisible && this.props.loadingText && (React.createElement("div", { className: "spinner__text" }, this.props.loadingText)),
            this.state.screenreaderVisible && this.props.screenreaderText && (React.createElement("div", { tabIndex: -1, className: "sr-only", ref: this.srRef }, this.props.screenreaderText))));
    };
    return Spinner;
}(React.Component));
exports.Spinner = Spinner;
/* tslint:disable:no-string-literal */
Spinner['defaultProps'] = {
    ariaLive: 'polite',
    isVisible: false,
    screenreaderText: 'Loading. Please wait.',
};
Spinner['propTypes'] = {
    ariaLive: PropTypes.string,
    isVisible: PropTypes.bool,
    loadingText: PropTypes.string,
    onClose: PropTypes.func,
    screenreaderText: PropTypes.string,
};
/* tslint:enable:no-string-literal */
